import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import UserGroupRules from 'core/redux/reducers/userGroupRules';

export const deleteUserGroupRule =
  (options: { id: string }, listId?: string): AppThunk =>
  async (dispatch) => {
    try {
      await apiClient.deleteUserGroupRule(options);
      dispatch(UserGroupRules.actions.remove(options, listId));
    } catch (error) {
      console.error(error);
    }
  };
